module.exports = new __parcel__URL__("archer-logo-mark.09728906.webp").toString();